export default __webpack_public_path__ + "static/media/fitnesszone.796db6a1.JPG";